// extracted by mini-css-extract-plugin
module.exports = {"messageText":"formMessage_messageText__1TlMD","messageSuccess":"formMessage_messageSuccess__2Mj37","messageFail":"formMessage_messageFail__2Rw0x"};